/* eslint-disable react-hooks/exhaustive-deps */
import { Column } from '@antv/g2plot';
import React, { useEffect, useRef, useState } from 'react';

import Frame from '../frame';
import Style from './style';
import Metrics from '../metrics';
import { mapData, getRange } from './helper';
import { useChartHelper } from '../../../../../../../helpers/Charts';

const CustomTooltipContent = (data, t, organisationName) => {
  const items = data ? data.map ? data.map((d) => `
    <div class="item">
      <div>
        <div class="identifier" style="background: ${d.color}"></div>
      </div>
      <div class="title">
        <span>${d.name === 'My Organisation' ? organisationName || t('My Organisation') : t(d.name)}</span>
      </div>
      <div class="value">
        <span>${d.value}</span>
      </div>
    </div>
  `) : [] : [];

  return `
    <div class="custom-tooltip">
      ${items.join('')}
    </div>
  `;
};

const MitigationActionsTrend = ({
  data = null,
  period = 'past12Months',
  t = (t) => t,
  organisationName = null,
}) => {
  const container = useRef();
  const [graph, setGraph] = useState(null);
  const [frameActions, setFrameActions] = useState(null);
  const [metricsValues, setMetricsValues] = useState([
    { color: "#237804", label: "My Organisation", labelToShow: organisationName, toggled: true },
    { color: "#95CE80", label: "Other Stakeholders", toggled: true },
  ]);

  useEffect(() => {
    setMetricsValues((prev) => [
      { ...prev[0], labelToShow: organisationName },
      prev[1],
    ]);
  }, [organisationName]);

  const {
    getFilteredData,
    getFilteredColors,
    getActiveFilterData,
    setDaily,
    setWeekly,
    setMonthly,
    initialConfig,
  } = useChartHelper({
    metricsValues,
    period,
    data,
    frameActions,
    t,
    graph,
    tooltTip: (data, t) => CustomTooltipContent(data, t, organisationName),
  });

  useEffect(() => {
    if (data) {
      if (data.pastMonth && data.past3Months && data.past12Months) {
        mapData({
          data,
          setDaily,
          setWeekly,
          setMonthly,
        });
      }
    }
  }, [data]);

  useEffect(() => {
    if (!graph && metricsValues && getActiveFilterData) {
      const d = getActiveFilterData || [];

      const plot = new Column(container.current, {
        data: d,
        ...initialConfig(metricsValues),
        isGroup: true,
        yAxis: {
          tickMethod: (a) => getRange(a.max),
        }
      });

      setGraph(plot);
      plot.render();
    } else if (graph && getActiveFilterData) {
      const d = getFilteredData(getActiveFilterData);
      graph.update({
        data: d,
        color: getFilteredColors,
        animation: false,
        tooltip: {
          customContent: (_, data) => CustomTooltipContent(data, t, organisationName),
        },
        yAxis: {
          tickMethod: (a) => getRange(a.max),
        },
      });
    }
  }, [metricsValues, getActiveFilterData]);

  return <Frame
    title={t('Corrective Actions')}
    onInit={actions => setFrameActions(actions)}
  >
    <Style>
      <div className="chart-container" ref={container} />
      {metricsValues && (
        <Metrics
          t={t}
          title={t('Dashboard::Implementation')}
          metricsValues={metricsValues}
          setMetricsValues={setMetricsValues}
        />
      )}
    </Style>
  </Frame>;
}

export default MitigationActionsTrend;
